// extracted by mini-css-extract-plugin
export default {"companyDetailsContainer":"DesktopFooter-module_companyDetailsContainer_BhGbrxN3fn","footer":"DesktopFooter-module_footer_ZGUhsiziR_"};